import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
// import { Component } from '@angular/core';
import { ToastController  } from '@ionic/angular';

import { ApiResponse } from '../../models/api-response';
import { DeviceInfo } from '../../models/device-Info';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  deviceSettings: DeviceInfo;

  constructor(private http: HttpClient, public toastController: ToastController, private ga: GoogleAnalytics) {}

  // Handle API errors
  handleError(error: HttpErrorResponse) {
    let errorMsg;
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMsg = 'An error occurred:' + error.error.message ;
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong
      errorMsg = console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
      console.error(errorMsg);
    }

    this.presentToast(errorMsg, 'danger');
    // log exception to Google Analytics
    this.ga.trackException(errorMsg, false);
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }

  getApiEndpoint(endpoint): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(endpoint)
    .pipe(
      retry(2),
      catchError(this.handleError)
    );
  }

  postApiEndpoint(endpoint, payload): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(endpoint, payload)
      .pipe(
        retry(2),
        catchError(this.handleError)
      );
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 5000,
      position: 'bottom',
      color
    });
    toast.present();
  }
}
